import loadable from "@loadable/component";

// Asynchronously load the MetaTags component using @loadable/component
// export { default as MetaTags } from "./Title";
export const MetaTags = loadable(() => import("./Title"));
